module.exports = __webpack_public_path__ + "img/module8.12e976d.png";